<template>
  <v-app>
    <div id="app">
      <div class="router-wrapper">
        <router-view/>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
  computed: {
    appBackground() {
      return this.$vuetify.theme.themes.light.primary;
    },
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
  width: 100%;
  white-space: nowrap;
  background-color: #ffffff;
  z-index: 0;
}
</style>
